// Author Shi Wenlong
// Date 2021-07-09 14:08:14

import * as model from "@/model/sithMes/quality/SithMesQualityToolScrapModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesQualityToolScrap(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_QUALITY_URL,
        callbackApi: process.env.VUE_APP_SITHMES_QUALITY_URL + '/sithMesQualityToolScrap/workflow/complete-feedback',
        processDefinitionKey: "quality_tool_scrap",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .buildStore()
